import React, { Component } from 'react';

import * as MicrosoftGraph from "@microsoft/microsoft-graph-client";
import { IPersonaProps } from "office-ui-fabric-react";
import { connect } from "react-redux";
import { IRootState } from "../store";
import ApiService from "./ApiService";
import UserSelectorBase, { UserOption } from './UserSelectorBase';
import * as _ from "lodash";

interface UserSelectorProps {
    tenantId: string;
    className: string;
    label?: string;
    selectedUsers?: (UserOption | string)[];
    onSelectionChanged: (selectedUsers: UserOption[]) => void;
    disabled: boolean;
    multiSelect: boolean;
    additionalFilter?: (undefined | "Teacher" | "Staff" | "Student")[];

    graphClient: MicrosoftGraph.Client;
    apiService: ApiService;
    userIsCdbEmployee: boolean;
}

interface UserSelectorState {
    selectedItems: IPersonaProps[];
}

class UserSelector extends Component<UserSelectorProps, UserSelectorState> {
    static displayName = UserSelector.name;

    constructor(props: UserSelectorProps) {
        super(props);

        this.state = {
            selectedItems: []
        };
    }

    componentDidMount(): void {

    }


    componentDidUpdate(prevProps: Readonly<UserSelectorProps>, prevState: Readonly<UserSelectorState>, snapshot?: any): void {

    }

    private fetchUserOptions = async (filter: string): Promise<UserOption[]> => {

        let users = [];

        let filterString = "";
        if (filter && filter !== "") {
            filterString = filterString + `startsWith(displayName,'${filter}') or startsWith(surname,'${filter}') or startsWith(userPrincipalName,'${filter}')`;

            if (filter.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i)) { // need to check if the value is a guid otherwise graph will throw an error
                filterString += ` or id eq '${filter}'`;
            }

            let filters = this.props.additionalFilter?.map(filter => {
                return `extension_fe2174665583431c953114ff7268b7b3_Education_ObjectType eq '${filter}'`;
            });

            if (filters !== undefined && filters.length !== 0) {
                filterString = `(${filterString}) AND (${filters!.join(" OR ")})`
            }
        }

        if (this.props.userIsCdbEmployee) {
            users = await this.props.apiService.searchGraphUsersAdmin(this.props.tenantId, filterString);
        }
        else {
            let reqBuilder = this.props.graphClient.api("/users");
            reqBuilder = reqBuilder.filter(filterString).top(300);
            const response = await reqBuilder.get();
            users = response.value;
        }

        return users;
    };

    render(): JSX.Element {
        return (
            <UserSelectorBase
                className={this.props.className}
                label={this.props.label}
                selectedUsers={this.props.selectedUsers}
                onSelectionChanged={this.props.onSelectionChanged}
                disabled={this.props.disabled}
                multiSelect={this.props.multiSelect}
                textExtraDetails={"Search by display name, surname or UserPrincipalName"}
                fetchUsers={this.fetchUserOptions} />
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { tenantId: string, className: string, label?: string, selectedUsers?: (UserOption | string)[], onSelectionChanged(selectedUsers: UserOption[]): void, disabled: boolean, multiSelect: boolean, additionalFilter?: (undefined | "Teacher" | "Staff" | "Student")[] }): UserSelectorProps => {
        return {
            tenantId: ownProps.tenantId,
            className: ownProps.className,
            label: ownProps.label,
            selectedUsers: ownProps.selectedUsers,
            onSelectionChanged: ownProps.onSelectionChanged,
            disabled: ownProps.disabled,
            multiSelect: ownProps.multiSelect,
            additionalFilter: ownProps.additionalFilter,

            graphClient: state.auth.graphClient,
            apiService: state.auth.apiService,
            userIsCdbEmployee: state.auth.userIsCdbEmployee
        };
    }
)(UserSelector)